import React from 'react';
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            confirmationEmailSend: false,
            email: null,
        };
    }

    handleSubmit(e) {
        e.preventDefault();

        const body = {'email': e.target.email.value, 'new_password': e.target.new_password.value, 'new_password_confirmation': e.target.new_password_confirmation.value};

        fetch(process.env.REACT_APP_API_URL + '/my-account/forgot-password', {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json'}
        }).then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        confirmationEmailSend: true,
                        email: e.target.email.value
                    });
                },
                (error) => {
                    this.setState({
                        confirmationEmailSend: false,
                        error: error
                    });
                }
            );
    }

    render() {
        const { confirmationEmailSend, error, email } = this.state;

        var content = null;

        if (error && confirmationEmailSend) {
            content = <h1>Something went wrong...</h1>
        } else if (confirmationEmailSend) {
            content = <h1>Confirmation email send to {email}</h1>
        } else {
            content = (<Row className="vh-100 d-flex justify-content-center align-items-center">
                <Col md={8} lg={6} xs={12}>
                    <div className="border border-3 border-primary"></div>
                    <Card className="shadow">
                        <Card.Body>
                            <div className="mb-3 mt-md-4">
                                <h2 className="fw-bold mb-2 text-uppercase ">ES</h2>
                                <p className=" mb-5">Don't forget password this time</p>
                                <div className="mb-3">
                                    <Form onSubmit={this.handleSubmit.bind(this)}>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label className="text-center">
                                                Email address
                                            </Form.Label>
                                            <Form.Control name="email" type="email" placeholder="Enter email" />
                                        </Form.Group>

                                        <Form.Group
                                            className="mb-3"
                                            controlId="formBasicPassword"
                                        >
                                            <Form.Label>New password</Form.Label>
                                            <Form.Control name="new_password"  type="password" placeholder="Password" />
                                        </Form.Group>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="formBasicPassword"
                                        >
                                            <Form.Label>Confirm new password</Form.Label>
                                            <Form.Control name="new_password_confirmation"  type="password" placeholder="Password" />
                                        </Form.Group>
                                        <div className="d-grid">
                                            <Button variant="primary" type="submit">
                                                Change
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>);
        }

        return <div>
            <Container>
                {content}
            </Container>
        </div>
    }
}

export default withRouter(ForgotPassword);
